import _ from 'lodash'

import { NUMBER_MAGNITUDES } from '../../constants'

/**
 * Returns minimal value across all data specific for financial table
 * @param {array} data Data from API
 * @returns {number} Minimal value
 */
export const getMinValueFromData = (data = []) => {
    const output = Math.min(
        ..._(data)
            .map((row) => _.map(row.values, (x) => Math.abs(x)))
            .flatten()
            .filter((x) => x !== 0)
            .value()
    )

    return output
}

/**
 * Returns a object containing magnitude based on input number
 * Returned object is specified in NUMBER_MAGNITUDES constant
 * @param {number} value - Input value used to get magnitude
 * @returns {object} Object containing magnitude
 * */
export const getNumberMagnitude = (value) => {
    if (!_.isFinite(value)) return null

    const numberLength = Math.abs(parseInt(value, 10)).toString().length

    return _.find(NUMBER_MAGNITUDES, ({ range }) => _.inRange(numberLength, ...range))
}

/**
 * Formats input value based on magnitude
 * @example
 * // Returns '12.69'
 * formatValueByMagnitude(12694207, { translate: 'million', base: 1000000 });
 * @param {number} value - Input value to be formatted
 * @param {object} magnitude - Object used to format value
 * @param {number} magnitude.base - Base of magnitude
 * @returns {string} Formatted string
 */
export const formatValueByMagnitude = (value, magnitude = { base: 0 }, decimalPlaces = 2) => {
    if (!_.isFinite(value) || _.isNil(value)) return '-'

    const { base } = magnitude
    const number = Math.abs(value)

    let output = (number / base)
        .toFixed(decimalPlaces)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    if (value < 0) output = `-${output}`

    return output
}

/**
 * Returns name of a CSS class based on currently selected sample and compare year
 * Columns with these classes are highlighted
 * @param {number} currYear Current column year used to get class
 * @param {number} sampleYear Currently selected sampleYear
 * @param {number} compareYear Currently selected compareYear
 * @returns {string} CSS class
 */
export const getCSSYearClass = (currYear, sampleYear, compareYear) => {
    if (currYear === sampleYear) return 'sample-year'
    if (currYear === compareYear) return 'compare-year'

    return null
}
